import Title from './index.vue';

export default Title;
